// src/types/enums.ts

// User Enums
export enum UserRole {
  ADMIN = "admin",
  EDITOR = "editor",
  LAWYER = "lawyer",
  TRAINEE = "trainee",
  GUEST = "guest"
}
export enum UserStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
  SUSPENDED = "suspended"
}

// Lawyer Enums
export enum LawyerStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
  SUSPENDED = "suspended"
}

// Subscriber Enums
export enum SubscriberStatus {
  PENDING = "pending",
  APPROVED = "approved",
  REJECTED = "rejected"
}

// Trainee Enums
export enum TraineeStatus {
  ACTIVE = "active",
  COMPLETED = "completed",
  TERMINATED = "terminated"
}

// Service Enums
export enum ServiceType {
  LAWYER = "lawyer",
  TRAINEE = "trainee",
  SUBSCRIBER = "subscriber"
}

// ServiceRequest Enums
export enum RequestStatus {
  PENDING = "pending",
  IN_PROGRESS = "in_progress",
  COMPLETED = "completed",
  REJECTED = "rejected"
}
export enum PaymentStatus {
  PENDING = "pending",
  PAID = "paid",
  FAILED = "failed"
}

// Subscription Enums
export enum SubscriptionStatus {
  ACTIVE = "active",
  EXPIRED = "expired",
  PENDING = "pending"
}

// Invoice Enums
export enum InvoiceType {
  SERVICE = "service",
  SUBSCRIPTION = "subscription"
}
export enum InvoiceStatus {
  PENDING = "pending",
  PAID = "paid",
  OVERDUE = "overdue",
  CANCELLED = "cancelled"
}

// Notification Enums
export enum NotificationType {
  SMS = "sms",
  IN_APP = "in-app"
}
export enum NotificationStatus {
  UNREAD = "unread",
  READ = "read"
}

// Complaint Enums
export enum ComplaintStatus {
  PENDING = "pending",
  UNDER_REVIEW = "under_review",
  RESOLVED = "resolved",
  REJECTED = "rejected"
}
// (2) !! الحل: إضافة ENUM لحالة طلب التدريب هنا !!
export enum TrainingRequestStatus {
  NOT_REQUESTED = "not_requested",
  PENDING = "pending",
  APPROVED = "approved",
  REJECTED = "rejected"
}